import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { fuseAnimations } from '../../../core/animations';
import { MatPaginator, MatSort } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import { Router } from "@angular/router";
import { ElasticSearchService } from '../../../core/services/elastic-search.service';
import * as firebase from 'firebase';
import { MatDialog } from '@angular/material';
import { AngularFirestore } from 'angularfire2/firestore';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-blog-list',
    templateUrl: './blog-list.component.html',
    styleUrls: ['./blog-list.component.scss'],
    animations: fuseAnimations,
    providers: [ElasticSearchService]
})
export class BlogListComponent implements OnInit {

    displayedColumns = ['name', 'category', 'delete'];
    onProductsChanged: BehaviorSubject<any> = new BehaviorSubject({});
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('filter') filter: ElementRef;
    @ViewChild(MatSort) sort: MatSort;
    number: any;
    product: Array<any>;
    dataSource: MyDataSource;
    input: any;
    filteredItems: Array<any>;
    roles: string;
    database = firebase.database();
    sub: any;
    constructor(

        private router: Router,
        private afs: AngularFirestore,
        private dialog: MatDialog,
        private elastic: ElasticSearchService) {

        this.sub = afs.collection('blog').snapshotChanges().pipe(map(actions => {
            return actions.map(data => {
                return {
                    $key: data.payload.doc.id,
                    ...data.payload.doc.data()
                }

            });

        })).subscribe(res => {
            this.number = res.length;
            this.product = res;
            this.onProductsChanged.next(this.product);
            this.dataSource = new MyDataSource(this.product, this.paginator, this.sort);
        });



    }

    navigate(key) {
        this.router.navigate(['/blog'], { queryParams: { key: key } });
    }



    ngOnInit() {
        this.roles = localStorage.getItem('currentUserRole');

    }

    deletePost(key) {
        this.afs.collection('blog').doc(key).delete();
    }
    changeTextCategory(string) {
        return string
            .replace(/ö/g, 'o')
            .replace(/Ö/g, 'o')
            .replace(/ç/g, 'c')
            .replace(/Ç/g, 'c')
            .replace(/ş/g, 's')
            .replace(/Ş/g, 's')
            .replace(/ı/g, 'i')
            .replace(/İ/g, 'i')
            .replace(/ğ/g, 'g')
            .replace(/Ğ/g, 'g')
            .replace(/ü/g, 'u')
            .replace(/Ü/g, 'u')
            .replace('&', 've')
            .replace(/,/g, '')
            .replace(/\./g, '_')
            .replace(/\'/g, '')
            .replace(/\s/g, '_').toLowerCase();
    }

    searchKeyUp(event) {
        console.log(this.input);
        const searchInput = this.input.replace(/\s/g, '').replace(/@/g, '').replace(/,/g, '').replace(/'/g, '').replace(/\./g, '').toLowerCase().trim();
        this.filteredItems = this.product.filter(
            item => {
                if (item.name !== undefined) {
                    console.log(item.name);


                    return this.changeTextCategory(item.name).indexOf(this.changeTextCategory(this.input)) > -1
                }
            });
        this.dataSource = new MyDataSource(this.filteredItems, this.paginator, this.sort);
    }

}

export class MyDataSource extends DataSource<any> {
    constructor(
        private data: any,
        private _paginator: MatPaginator,
        private _sort: MatSort) {
        super();
    }
    _filterChange = new BehaviorSubject('');
    _filteredDataChange = new BehaviorSubject('');

    get filteredData(): any {
        return this._filteredDataChange.value;
    }

    set filteredData(value: any) {
        this._filteredDataChange.next(value);
    }

    get filter(): string {
        return this._filterChange.value;
    }

    set filter(filter: string) {
        this._filterChange.next(filter);
    }
    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<any[]> {
        const displayDataChanges = [
            this.data,
            this._paginator.page,
            this._filterChange,
            this._sort.sortChange
        ];
        return Observable.merge(...displayDataChanges).map(() => {
            let data = this.data.slice();

            this.filteredData = [...data];

            data = this.sortData(data);

            // Grab the page's slice of data.
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            return data.splice(startIndex, this._paginator.pageSize);
        });
    }

    sortData(data): any[] {
        if (!this._sort.active || this._sort.direction === '') {
            return data;
        }

        return data.sort((a, b) => {
            let propertyA: number | string = '';
            let propertyB: number | string = '';

            switch (this._sort.active) {
                case 'id':
                    [propertyA, propertyB] = [a.id, b.id];
                    break;
                case 'name':
                    [propertyA, propertyB] = [a.name, b.name];
                    break;
                case 'categories':
                    [propertyA, propertyB] = [a.categories[0], b.categories[0]];
                    break;
                case 'price':
                    [propertyA, propertyB] = [a.priceTaxIncl, b.priceTaxIncl];
                    break;
                case 'quantity':
                    [propertyA, propertyB] = [a.quantity, b.quantity];
                    break;
                case 'active':
                    [propertyA, propertyB] = [a.active, b.active];
                    break;
            }

            const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
        });
    }

    disconnect() { }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/blog-list/blog-list.component.ts